import React from 'react';
import { noop } from 'lodash';

import OtpFeature from '@features/otp';
import {
  useExternalElearningResendOtp,
  useExternalElearningVerifyOtp
} from '@services/elearning-external';

import { useExternalElearningFlow } from './shared/eel-flow-context';

function ExternalElearningOtpPage() {
  const { goNext } = useExternalElearningFlow();
  const { mutateAsync: verifyOtp, isPending } = useExternalElearningVerifyOtp();
  const { mutateAsync: resendOtp, isPending: isResending } =
    useExternalElearningResendOtp();

  return (
    <OtpFeature
      onVerify={(otp) => verifyOtp(otp).then(goNext).catch(noop)}
      onResend={() => resendOtp().then(() => {})}
      isPending={isPending}
      isResending={isResending}
    />
  );
}

export default ExternalElearningOtpPage;
